module.exports = __webpack_public_path__ + "img/instagram.9b7d33de.png";